
import {Component, Prop, Vue} from "vue-property-decorator";
import {stringify} from "@/auxillary/datafield.stringify";
import ReadonlyDataField from "@/models/ReadonlyDataField";
import dataFieldTypesReadonly from "@/dataFieldReadonlyTypes";

@Component({
  name: 'EventReportListEntryFieldReadonly',
  components: {
    ...dataFieldTypesReadonly,
  },
})
export default class EventReportListEntryFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";
  saving = false;
  isEditing = false;

  get field() {
    return this.dataField;
  }

  /*
  The field has an event report that was sent (processed by aeReportSender).
   */
  private get hasSentEventReport(): boolean {
    return this.field.values.eventReportSendDate != undefined;
  }

  /*
  The field has an event report no matter if it was sent.
   */
  private get hasEventReport(): boolean {
    return this.field.values.eventReportIdentifier != undefined;
  }

  get hasSignature() {
    return this.field?.tags?.signature != null;
  }

  get isDeactivated() {
    return this.field?.tags?.isDeactivated === true
  }

  get deactivationReason() {
    return this.field?.tags?.deactivationReason ?? "";
  }

  get isVisible() {
    return this.dataField?.isVisible ?? false;
  }

  get childNames() {
    return this.dataField.definition.names ?? [{
      template: "{0}",
      field: ["name"]
    }];
  }

  get childName() {

    let name = "";

    for (const childName of this.childNames) {
      // find field
      let field: any = undefined;
      for (const fieldIdentifier of childName.field) {
        if (field === undefined) {
          field = this.childFields.find(d => d.identifier == fieldIdentifier)
          if (field === undefined)
            break;
          continue;
        }

        field = field.childFields.find((d: any) => d.identifier == fieldIdentifier)
        if (field === undefined)
          break;
      }
      if (field?.values == null)
        continue;

      const fieldName = stringify(field);
      if (fieldName)
        name += childName.template.replace("{0}", fieldName);
    }

    if (name == "")
      return "(keine Eintragung)";

    return name;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get stringifyValue() {
    return stringify(this.dataField)
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }

  mounted() {
  }
}
